
import { Vue, Component, Prop } from "vue-property-decorator";

import FormInput from "@/components/form/FormInput.vue";

@Component({
  components: {
    FormInput,
  },
})
export default class FormInputGroup extends Vue {
  @Prop({ type: String, default: undefined }) readonly inputClasses?: string;
  @Prop({ type: String, default: undefined }) readonly prefix?: string;
  @Prop({ type: String, default: undefined }) readonly suffix?: string;
  @Prop({ type: Boolean, default: false }) readonly withIcon?: boolean;
  @Prop({ type: Boolean, default: '' }) readonly suffixClasses?: string;
  @Prop({ type: Boolean, default: '' }) readonly prefixClasses?: string;
}
